import { render, staticRenderFns } from "./FunctionalModerationDetails.vue?vue&type=template&id=412d4bbc&scoped=true"
import script from "./FunctionalModerationDetails.vue?vue&type=script&lang=js"
export * from "./FunctionalModerationDetails.vue?vue&type=script&lang=js"
import style0 from "./FunctionalModerationDetails.vue?vue&type=style&index=0&id=412d4bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412d4bbc",
  null
  
)

export default component.exports